import React, { Component } from "react";
import {
    Card,
    CardBody,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import "./mobileuser.css";
import axios from "axios";
import { configuration } from "../../../appConfig";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});
class DatCredentials extends Component {
    state = {
        words: {},
        lang: "",
        username: "",
        password: "",
        customerLogin: "",
        customerId: "",
        type: "",
        interphaseSignature: "",
        customerSignature: "",
        showPassword: false,
        showcustomerSignature: false,
        tableData: [],
        errors: [],
        status: '',
        modelEdit: false,
        modalActive: false,
        updateCustomerId: '',
        updateCustomerLogin: '',
        updatePassword: '',
        updateCustomerSignature: '',
        updateType: '',
        editModelErrors: {},
        showPassword: false,
        showcustomerSignature: false,
    };

    componentDidMount() {
        // Fetch initial data if needed
        this.getLang()
    }

    getLang = () => {
        const base_url = window.location.origin;
        axios.get(`${base_url}/lang.json`).then((res) => {
            this.setState({ words: res.data, lang: localStorage.getItem("lang") });
        });
    };

    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };

    handleToggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };
    handleToggleShowcustomerSignature = () => {
        this.setState({ showcustomerSignature: !this.state.showcustomerSignature });
    };

    handleDropdownChange = (e) => {
        this.setState({ type: e.target.value });
    };

    handleEditDropdownChange = (e) => {
        this.setState({ updateType: e.target.value });
    };

    handleEditModelOpen = (row) => {
        this.setState({
            modelEdit: true,
            updateCustomerId: row.customer_id,
            updateCustomerLogin: row.username,
            updatePassword: row.password,
            updateCustomerSignature: row.sign,
            updateType: row.type,
        });
    };

    handleStatusChange = (row, status) => {
        this.setState({
            modalActive: true,
            status: status,
            customerId: row.customer_id,
            customerLogin: row.username,
            password: row.password,
            customerSignature: row.sign,
            type: row.type,
        });
    };

    handleList = async () => {
        const partnerID = localStorage.getItem("partnerId")
        try {
            const response = await axios.get(`${configuration.getThirdPartyCredential}?partnerId=${partnerID}&search=&page=1&limit=10`);
            this.setState({ tableData: response.data.data });
        } catch (error) {
            this.setState({ errors: [...this.state.errors, error.message] });
        }
    };

    handleStatusActiveDeactive = async (event) => {
        event.preventDefault();
        const url = configuration.postThirdPartyCredential;
        const payload = {
            partnerId: localStorage.getItem("partnerId"),
            data: [
                {
                    type: this.state.type,
                    username: this.state.customerLogin,
                    password: this.state.password,
                    customer_id: this.state.customerId,
                    sign: this.state.customerSignature,
                    is_active: this.state.status == "active" ? "1" : '0'
                }
            ]
        };

        try {
            const response = await axios.post(url, payload);

            if (response.data.status == 'true') {
                this.handleList();
                Toast.fire({
                    type: "success",
                    title: `DAT Credential Updated successfully.`,
                });
                this.setState({
                    modalActive: false,
                    password: "",
                    customerLogin: "",
                    customerId: "",
                    customerSignature: "",
                    type: "",
                    status: '',
                    errors: []
                });

            }
        } catch (err) {
            Toast.fire({
                type: "error",
                title: `Something Went Wrong!!.`,
            });
            this.setState({
                modalActive: false,
                password: "",
                customerLogin: "",
                customerId: "",
                customerSignature: "",
                type: "",
                status: '',
                errors: []
            });
        }
    };

    validateForm = () => {
        const { customerId, customerLogin, password, type, customerSignature } = this.state;
        const errors = [];

        if (!customerId.trim()) {
            errors.push("DAT-Kundennummer is required.");
        }
        if (!customerLogin.trim()) {
            errors.push("Benutzer is required.");
        }
        if (!password.trim()) {
            errors.push("Password is required.");
        }
        if (type === "select Type" || !type.trim()) {
            errors.push("DAT Type is required.");
        }
        if (!customerSignature.trim()) {
            errors.push("Customer Signature is required.");
        }

        if (!this.state.updateCustomerId) {
            errors.updateCustomerId = "DAT-Kundennummer is required";
        }
        if (!this.state.updateCustomerLogin) {
            errors.updateCustomerLogin = "Benutzer is required";
        }
        if (!this.state.updatePassword) {
            errors.updatePassword = "Password is required";
        }
        if (!this.state.updateType || this.state.updateType === "select Type") {
            errors.updateType = "Please select a valid DAT Type";
        }

        this.setState({ errors });
        return errors.length === 0;
    };

    handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!this.validateForm()) {
            setTimeout(() => {
                this.setState({ errors: [] });
            }, 3000);
            return;
        }

        const url = configuration.postThirdPartyCredential;
        const payload = {
            partnerId: localStorage.getItem("partnerId"),
            data: [
                {
                    type: this.state.type,
                    username: this.state.customerLogin,
                    password: this.state.password,
                    customer_id: this.state.customerId,
                    sign: this.state.customerSignature,
                    is_active: this.state.status || 0
                }
            ]
        };

        try {
            await axios.post(url, payload);
            Toast.fire({
                type: "success",
                title: `DAT Credential Added successfully.`,
            });
            this.setState({
                password: "",
                customerLogin: "",
                customerId: "",
                customerSignature: "",
                type: "",
                status: '',
                errors: []
            });
        } catch (error) {
            this.setState({ errors: [...this.state.errors, error.message] });
        }
    };

    updateUser = async (event) => {
    event.preventDefault();

    if (!this.validateForm()) {
        setTimeout(() => {
            this.setState({ errors: [] });
        }, 3000);
        // return; 
    }

    // Prepare API call payload
    const url = configuration.postThirdPartyCredential;
    const payload = {
        partnerId: localStorage.getItem("partnerId"),
        data: [
            {
                type: this.state.updateType,
                username: this.state.updateCustomerLogin,
                password: this.state.updatePassword,
                customer_id: this.state.updateCustomerId,
                sign: this.state.updateCustomerSignature,
                is_active: 0
            }
        ]
    };

    try {
        // Make the API call
        const response = await axios.post(url, payload);

        if (response.data.status === 'true') {
            // Handle success
            this.handleList();
            this.setState({
                modelEdit: false,
                updatePassword: "",
                updateCustomerLogin: "",
                updateCustomerId: "",
                updateCustomerSignature: "",
                updateType: "",
                status: '',
                errors: []
            });
            Toast.fire({
                type: "success",
                title: `DAT Credential Updated successfully.`,
            });
        } else {
            // Handle error returned by the API
            this.setState({ errors: [...this.state.errors, 'Something went wrong'] });
        }
    } catch (error) {
        // Handle network or other errors
        this.setState({ errors: [...this.state.errors, error.message] });
    }
};

    render() {
        const { showPassword, showcustomerSignature, tableData, errors } = this.state;

        return (
            <div className="mobile_user_main_wrapper">
                <Row className="justify-content-center">
                    <Col xl={10} lg={11} md={12} sm={12}>
                        <ul className="nav nav-pills mb-0" id="user-profile-wrapper" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link active"
                                    id="add-mobileuser-details-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#add-mobileuser-details"
                                    type="button"
                                    role="tab"
                                    aria-controls="add-mobileuser-details"
                                    aria-selected="true"
                                >
                                    Add Credentials
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link"
                                    id="mobileuser-list-details-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#mobileuser-list-details"
                                    type="button"
                                    role="tab"
                                    aria-controls="mobileuser-list-details"
                                    aria-selected="false"
                                    onClick={this.handleList}
                                >
                                    Credentials List
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="user-profile-wrapperContent">
                            <div
                                className="tab-pane fade show active"
                                id="add-mobileuser-details"
                                role="tabpanel"
                                aria-labelledby="add-mobileuser-details-tab"
                            >
                                <Card className="mobile_user_card">
                                    <CardBody>
                                        <form>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="form-group mobile_user_input">
                                                        <label>DAT-Kundennummer <span className="label_red">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="DAT-Kundennummer"
                                                            value={this.state.customerId}
                                                            onChange={(e) => this.setState({ customerId: e.target.value })}
                                                        />
                                                        {errors.includes("DAT-Kundennummer is required.") && (
                                                            <div className="text-danger">DAT-Kundennummer is required.</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="form-group mobile_user_input">
                                                        <label>Benutzer <span className="label_red">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Benutzer"
                                                            value={this.state.customerLogin}
                                                            onChange={(e) => this.setState({ customerLogin: e.target.value })}
                                                        />
                                                        {errors.includes("Benutzer is required.") && (
                                                            <div className="text-danger">Benutzer is required.</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="form-group mobile_user_input">
                                                        <label>Password <span className="label_red">*</span></label>
                                                        <div className="position-relative">
                                                            <input
                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control"
                                                                placeholder="Password"
                                                                value={this.state.password}
                                                                onChange={(e) => this.setState({ password: e.target.value })}
                                                            />
                                                            <div
                                                                className="password-icon"
                                                                onClick={this.handleToggleShowPassword}
                                                            >
                                                                <i
                                                                    className={
                                                                        showPassword
                                                                            ? "fa fa-eye"
                                                                            : "fa fa-eye-slash"
                                                                    }
                                                                ></i>
                                                            </div>
                                                            {errors.includes("Password is required.") && (
                                                                <div className="text-danger">Password is required.</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="form-group mobile_user_input">
                                                        <label>Customer Signature <span className="label_red">*</span></label>
                                                        <div className="position-relative">
                                                            <input
                                                                type={showcustomerSignature ? "text" : "password"}
                                                                className="form-control"
                                                                placeholder="Customer Signature"
                                                                value={this.state.customerSignature}
                                                                onChange={(e) => this.setState({ customerSignature: e.target.value })}
                                                            />
                                                            <div
                                                                className="password-icon"
                                                                onClick={this.handleToggleShowcustomerSignature}
                                                            >
                                                                <i
                                                                    className={
                                                                        showcustomerSignature
                                                                            ? "fa fa-eye"
                                                                            : "fa fa-eye-slash"
                                                                    }
                                                                ></i>
                                                            </div>
                                                        </div>
                                                        {errors.includes("Customer Signature is required.") && (
                                                                <div className="text-danger">Customer Signature is required.</div>
                                                            )}
                                                             <span>{this.lang("dat_generate_signature")}</span><a href="https://www.hashgenerator.de/" target="_blank"> Click here...</a>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="form-group mobile_user_input">
                                                        <label>DAT Type <span className="label_red">*</span></label>
                                                        <select
                                                            className="form-control"
                                                            value={this.state.type}
                                                            onChange={this.handleDropdownChange}
                                                        >
                                                            <option value="select Type">Select Type</option>
                                                            <option value="dat">{this.lang("dat")}</option>
                                                            <option value="dat_calculate">{this.lang("dat_calculate")}</option>
                                                            <option value="dat_gold">{this.lang("dat_gold")}</option>
                                                            <option value="dat_silver">{this.lang("dat_silver")}</option>
                                                        </select>
                                                        {errors.includes("DAT Type is required.") && (
                                                            <div className="text-danger">DAT Type is required.</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12 d-flex">
                                                    <div className="form-group mobile_user_input">
                                                        {this.state.type == 'dat' ?
                                                            <img
                                                                className="insurance_logo_img"
                                                                alt={this.state.InsurenceName}
                                                                src="../assets/images/dat.svg"
                                                            />
                                                            : this.state.type == 'dat_gold' ?
                                                                <img
                                                                    className="insurance_logo_img"
                                                                    alt={this.state.InsurenceName}
                                                                    src="../assets/images/fastrackGold.png"
                                                                />
                                                                : this.state.type == 'dat_silver' ?
                                                                    <img
                                                                        className="insurance_logo_img"
                                                                        alt={this.state.InsurenceName}
                                                                        src="../assets/images/dat-fasttrack-ai.png"
                                                                    />
                                                                    : this.state.type == 'dat_calculate' ?
                                                                        <img
                                                                            className="insurance_logo_img"
                                                                            alt={this.state.InsurenceName}
                                                                            src="../assets/images/DatCalculateExpert.png"
                                                                        />
                                                                        : ''
                                                        }

                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="form-group mobile_user_input">
                                                        <button type="submit" className="btn pull-right theme_button" onClick={(e) => this.handleFormSubmit(e)}>
                                                            Add Credentials
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </CardBody>
                                </Card>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="mobileuser-list-details"
                                role="tabpanel"
                                aria-labelledby="mobileuser-list-details-tab"
                            >
                                <Card className="mobile_user_card">
                                    <CardBody>
                                        <div className="row mobileuser_search_main_wrapper mt-2 justify-content-between">
                                            {/* <div className="col-lg-2 col-md-3 col-sm-12">
                                                <div className="form-group mb-0">
                                                    <select
                                                        className="form-control"
                                                        name="recordsPerPage"
                                                    >
                                                        <option>10</option>
                                                        <option>20</option>
                                                        <option>30</option>
                                                        <option>40</option>
                                                        <option>50</option>
                                                        <option>60</option>
                                                        <option>70</option>
                                                        <option>80</option>
                                                        <option>90</option>
                                                        <option>100</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="form-group mb-0">
                                                    <input
                                                        type="text"
                                                        name="searchUser"
                                                        className="form-control"
                                                        placeholder="Search"
                                                    />
                                                </div>
                                                <button className="close_button main_close__search">
                                                    <i className="fa fa-close"></i>
                                                </button>
                                                <button className="search_icon_button">
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div> */}
                                        </div>
                                        <div className="row mt-0">
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center">Sr. No.</th>
                                                                <th className="text-center">Image</th>
                                                                <th className="text-center">DAT Type</th>
                                                                <th className="text-center">DAT-Kundennummerr</th>
                                                                <th className="text-center">Benutzer</th>
                                                                <th className="text-center">Password</th>
                                                                <th className="text-center">Customer Signature</th>
                                                                <th className="text-center">Status</th>
                                                                <th className="text-center">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {tableData.length > 0 ? tableData.map((row, index) => (
                                                                <>
                                                                    <tr>
                                                                        <td className="text-center">{index + 1}</td>
                                                                        <td className="text-center">
                                                                            <div className="dat_type_logo">
                                                                                {row.type == 'dat' ?
                                                                                    <img
                                                                                        className="insurance_logo_img"
                                                                                        alt={row.InsurenceName}
                                                                                        src="../assets/images/dat.svg"
                                                                                    />
                                                                                    : row.type == 'dat_gold' ?
                                                                                        <img
                                                                                            className="insurance_logo_img"
                                                                                            alt={row.InsurenceName}
                                                                                            src="../assets/images/fastrackGold.png"
                                                                                        />
                                                                                        : row.type == 'dat_silver' ?
                                                                                            <img
                                                                                                className="insurance_logo_img"
                                                                                                alt={row.InsurenceName}
                                                                                                src="../assets/images/dat-fasttrack-ai.png"
                                                                                            />
                                                                                            : row.type == 'dat_calculate' ?
                                                                                                <img
                                                                                                    className="insurance_logo_img"
                                                                                                    alt={row.InsurenceName}
                                                                                                    src="../assets/images/DatCalculateExpert.png"
                                                                                                />
                                                                                                : ''
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-center">{row.type}</td>
                                                                        <td className="text-center">{row.customer_id}</td>
                                                                        <td className="text-center">{row.username}</td>
                                                                        {/* <td className="text-center">{row.password}</td>
                                                                        <td className="text-center">{row.sign}</td> */}
                                                                        <td className="text-center" style={{ fontSize: '20px' }}>{row.password.substring(0, 5).replace(/./g, '*')}</td>
                                                                        <td className="text-center" style={{ fontSize: '20px' }}>{row.sign.substring(0, 5).replace(/./g, '*')}</td>
                                                                        {/* <td className="order-status-row text-center active">{row.is_active}</td> */}
                                                                        <td className={`order-status-row text-center ${row.is_active === "1" ? "active" : "deactive"}`}>{row.is_active === "1" ? "active" : "deactive"}</td>
                                                                        <td className="text-center">
                                                                            <div className='text-center'>
                                                                                <button className='edit_btn' onClick={() => this.handleEditModelOpen(row)}><i className='fa fa-pencil'></i></button>
                                                                                {/* <button className='deactive_btn'><i className='fa fa-times'></i></button> */}
                                                                                {row.is_active === "1" && (
                                                                                    <button
                                                                                        className="deactive_btn"
                                                                                        onClick={() =>
                                                                                            this.handleStatusChange(row, "deactive")
                                                                                        }
                                                                                    >
                                                                                        <i className="fa fa-times"></i>
                                                                                    </button>
                                                                                )}
                                                                                {row.is_active === "0" && (
                                                                                    <button
                                                                                        className="active_btn"
                                                                                        onClick={() =>
                                                                                            this.handleStatusChange(row, "active")
                                                                                        }
                                                                                    >
                                                                                        <i className="fa fa-check"></i>
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center">No data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Modal centered={true} size="xl" isOpen={this.state.modelEdit} className="theme_modal_user" backdrop="static"
                    toggle={() => this.setState({ modelEdit: false })}
                >
                    <ModalHeader toggle={() => this.setState({ modelEdit: false, errors: [] })} className="p-3">
                        Update DAT Credentials
                    </ModalHeader>
                    <form>
                        <ModalBody>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group mobile_user_input">
                                        <label>DAT-Kundennummer <span className="label_red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="DAT-Kundennummer"
                                            value={this.state.updateCustomerId}
                                            onChange={(e) => this.setState({ updateCustomerId: e.target.value })}
                                        />
                                        {errors.updateCustomerId && <div className="text-danger">{errors.updateCustomerId}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group mobile_user_input">
                                        <label>Benutzer <span className="label_red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Benutzer"
                                            value={this.state.updateCustomerLogin}
                                            onChange={(e) => this.setState({ updateCustomerLogin: e.target.value })}
                                        />
                                        {errors.updateCustomerLogin && <div className="text-danger">{errors.updateCustomerLogin}</div>}
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group mobile_user_input">
                                        <label>Password <span className="label_red">*</span></label>
                                        <div className="position-relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control"
                                                placeholder="Password"
                                                value={this.state.updatePassword}
                                                onChange={(e) => this.setState({ updatePassword: e.target.value })}
                                            />
                                            <div
                                                className="password-icon"
                                                onClick={this.handleToggleShowPassword}
                                            >
                                                <i
                                                    className={
                                                        showPassword
                                                            ? "fa fa-eye"
                                                            : "fa fa-eye-slash"
                                                    }
                                                ></i>
                                            </div>
                                        </div>
                                        {errors.updatePassword && <div className="text-danger">{errors.updatePassword}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group mobile_user_input">
                                        <label>Customer Signature</label>
                                        <div className="position-relative">
                                            <input
                                                type={showcustomerSignature ? "text" : "password"}
                                                className="form-control"
                                                placeholder="Customer Signature"
                                                value={this.state.updateCustomerSignature}
                                                onChange={(e) => this.setState({ updateCustomerSignature: e.target.value })}
                                            />
                                            <div
                                                className="password-icon"
                                                onClick={this.handleToggleShowcustomerSignature}
                                            >
                                                <i
                                                    className={
                                                        showcustomerSignature
                                                            ? "fa fa-eye"
                                                            : "fa fa-eye-slash"
                                                    }
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group mobile_user_input">
                                        <label>DAT Type <span className="label_red">*</span></label>
                                        <select
                                            className="form-control"
                                            value={this.state.updateType}
                                            onChange={this.handleEditDropdownChange}
                                        >
                                            <option value="select Type">Select Type</option>
                                            <option value="dat">dat</option>
                                            <option value="dat_gold">dat_gold</option>
                                            <option value="dat_silver">dat_silver</option>
                                            <option value="dat_calculate">dat_calculate</option>
                                        </select>
                                        {errors.updateType && <div className="text-danger">{errors.updateType}</div>}
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <div>
                                <button
                                    className="btn btn-md p-2 mr-2 cancel_btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({
                                            modelEdit: false,
                                            errors: [],
                                            updateCustomerId: '',
                                            updateCustomerLogin: '',
                                            updateCustomerSignature: '',
                                            updatePassword: '',
                                            updateType: '',
                                        });
                                    }}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-md p-2 submit_button" onClick={(e) => this.updateUser(e)}>
                                    Submit
                                </button>
                            </div>
                        </ModalFooter>
                    </form>
                </Modal>

                <Modal
                    centered={true}
                    size="md"
                    isOpen={this.state.modalActive}
                    className="theme_modal_user"
                    backdrop="static"
                    toggle={() => this.setState({ modalActive: false })}
                >
                    <form>
                        <ModalBody>
                            <h4>
                                <b>
                                {this.state.status == "deactive" ? 
                                    this.lang("Are you sure you want to deactivate this DAT Credential?")
                                :
                                    this.lang("Are you sure you want to activate this DAT Credential?")}
                                </b>
                            </h4>

                        </ModalBody>
                        <ModalFooter>
                            <div>
                                <button
                                    className="btn btn-md p-2 mr-2 cancel_btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ modalActive: false, errors: [] });
                                    }}
                                >
                                    cancel
                                </button>
                                <button
                                    className="btn btn-md p-2 submit_button"
                                    onClick={(e) => this.handleStatusActiveDeactive(e)}
                                >
                                    {this.state.status}
                                </button>
                            </div>
                        </ModalFooter>
                    </form>
                </Modal>
            </div>
        );
    }
}

export default DatCredentials;
